import styles from './select.module.scss';
import MaterialSelect from '@mui/material/Select';
import FormControl from '../form-control/form-control';
import FilledInput from '@mui/material/FilledInput';
import { Checkbox, ListItemText, MenuItem } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface SelectProps {
  autoWidth?: boolean,
  children?: any,
  placeholder?: any
  // classes?: object,
  // defaultOpen?: boolean,
  // defaultValue?: any,
  displayEmpty?: boolean,
  // IconComponent?: any,
  // id?: string,
  input?: any,
  // inputProps?: object,
  label?: any,
  // labelId?: string,
  MenuProps?: object,
  multiple?: boolean,
  // native?: boolean,
  onChange?: (event: any) => void,
  onClose?: (event: any) => void,
  onOpen?: (event: any) => void,
  open?: boolean,
  renderValue?: any,
  // SelectDisplayProps?: object,
  sx?: any,
  value?: any,
  variant?: 'filled' | 'outlined' | 'standard',
  className?: string,
  size?: 'small' | 'medium',
  name?: string,
  fullWidth?: boolean,
  error?: boolean,
  disabled?: boolean,
  hiddenLabel?: boolean
}

export interface MultiSelectProps {
  value: any,
  options: any,
  keyValue: any,
  displayValue: any,
  onChange: (event: any) => void,
  renderValue: any,
  label: any,
}

export function Select(props: SelectProps) {
  return (
    <FormControl
      fullWidth={props.fullWidth}
      label={props.label}
      error={props.error}
      hiddenLabel={props.hiddenLabel || true}>
      <MaterialSelect
        autoWidth={props.autoWidth}
        placeholder={props.placeholder}
        value={props.value}
        renderValue={props.renderValue}
        MenuProps={props.MenuProps}
        multiple={props.multiple}
        onChange={props.onChange}
        onOpen={props.onOpen}
        onClose={props.onClose}
        disabled={props.disabled}
        size={props.size || 'small'}
        variant={props.variant || 'filled'}
        displayEmpty={props.displayEmpty}
        sx={props.sx}
        input={props.input}
        open={props.open}
        className={props.className}
        name={props.name}>
        {props.children}
      </MaterialSelect>
    </FormControl>
  )
}

export function MultiSelect(props: MultiSelectProps) {
  return (
    <Select
      label={props.label}
      multiple
      fullWidth
      value={props.value}
      onChange={props.onChange}
      input={<FilledInput />}
      renderValue={props.renderValue}>
      {props.options?.map((el: any) => (
        <MenuItem key={el[props.keyValue]} value={el}>
          <Checkbox checked={props.value.findIndex((u: any) => u[props.keyValue] === el[props.keyValue]) > -1} />
          <ListItemText primary={el[props.displayValue]} />
        </MenuItem>
      ))}
    </Select>
  );
}

export default Select;